/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import '../../scss/backoffice.scss';
import '../../scss/backend/manage-consent.scss';

import { Sidemenu } from './Sidemenu';
import { Topbar } from './Topbar';
import { Footer } from './Footers';
import { ToastContainer } from 'react-toastify';

import { PurposeType, PurposeStatusType } from '../../model/consent.data-type';

import { InputGroup, Form, Button } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { ConsentDetailModal } from '../../modal/backend/ConsentDetailModal';
import { OneTrustCredentialModal } from '../../modal/backend/OneTrustCredentialModal';
import { EmailConfigModal } from '../../modal/backend/EmailConfigModal';
import Swal from 'sweetalert2';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import {
  GetOneTrustPurposes,
  GetPPTPurposes,
  GetActivePurposes,
  SetPurpose,
  SortPurpose,
  DeletePurpose,
} from '../../services/ApiConsent';

import checkPurposeIsReadyToUse from '../../helpers/CheckPurposeIsReadyToUse';

const PPT_ORGANIZATION_ID = process.env.REACT_APP_ONE_TRUST_PPT_ORGANIZATION;

export const Consent = () => {
  const [alertOptions, setAlertOptions] = useState<any>({
    title: 'Warning!',
    text: 'Are you sure you want to do this action?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
  });
  const [duplicateAlertOptions, setDuplicateAlertOptions] = useState<any>({
    icon: 'warning',
    title: 'Warning!',
    text: 'Purpose is duplicated!',
  });

  const [hasError, setHasError] = useState(false);
  const [displayFullScreenLoading, setDisplayFullScreenLoading] =
    useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = (purpose: PurposeType) => {
    setPurposeDetail(purpose);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const [currentWiggingPurpose, setCurrentWiggingPurpose] = useState<any>();
  const [isFetchingAll, setIsFetchingAll] = useState(false);
  const [isFetchingPending, setIsFetchingPending] = useState(false);
  const [isFetchingActive, setIsFetchingActive] = useState(false);

  const [activeRefreshPurposes, setRefreshActivePurposes] = useState(false);
  const [backupAllPurposes, setBackupAllPurposes] = useState<
    PurposeType[] | []
  >([]);
  const [allPurposes, setAllPurposes] = useState<PurposeType[] | []>([]);
  const [bufferPurposes, setBufferPurposes] = useState<PurposeType[] | []>([]);
  const [activePurposes, setActivePurposes] = useState<PurposeType[] | []>([]);
  const [originalActivePurposes, setOriginalActivePurposes] = useState<
    PurposeType[] | []
  >([]);
  const [purposeDetail, setPurposeDetail] = useState<PurposeType>({
    purposeId: '',
    label: '',
    description: '',
    version: 0,
    organizations: [],
  });
  const [purposeToDelete, setPurposeToDelete] = useState<any>();
  const [showOneTrustCredentialModal, setShowOneTrustCredentialModal] =
    useState(false);
  const [showEmailConfigModal, setShowEmailConfigModal] = useState(false);
  const [tokenIsUpdated, setTokenIsUpdated] = useState(false);
  const [dropResult, setDropResult] = useState<any>(false);

  const [requestToAutoTriggerPurpose, setRequestToAutoTriggerPurpose] =
    useState<any>(false);
  const [validToAutoTriggerPurpose, setValidToAutoTriggerPurpose] =
    useState<any>(false);

  useEffect(() => {
    setDisplayFullScreenLoading(true);
    setIsFetchingAll(true);
    setIsFetchingPending(true);

    (async () => {
      try {
        const oneTrustPurposes = await GetOneTrustPurposes();
        const purposes = convertOneTrustResToPPT(oneTrustPurposes);

        if (purposes?.length) {
          setAllPurposes(purposes);
          setBackupAllPurposes(purposes);

          setIsFetchingAll(false);
        }

        const pendingPurposesRes = await GetPPTPurposes();
        const PPTPurposes = convertOneTrustResToPPT(pendingPurposesRes);

        if (PPTPurposes?.length) {
          setBufferPurposes(PPTPurposes);

          setIsFetchingPending(false);
          setDisplayFullScreenLoading(false);
        }
      } catch (error) {
        setHasError(true);
      }
    })();
  }, []);

  const convertOneTrustResToPPT = (res: any) => {
    const purposes = res?.content?.map((p: any) => {
      return {
        purposeId: p?.purposeId,
        label: p?.versions[0]?.label,
        description: p?.versions[0]?.description,
        version: p?.versions[0]?.version,
        organizations: p?.versions[0]?.organizations,
      };
    });

    return purposes || [];
  };

  useEffect(() => {
    setDisplayFullScreenLoading(true);
    setIsFetchingActive(true);

    (async () => {
      try {
        let activePurposesRes = await GetActivePurposes();

        if (activePurposesRes) {
          // sort purposes
          activePurposesRes = activePurposesRes?.sort(
            (a: any, b: any) => a.sort - b.sort,
          );

          setActivePurposes(activePurposesRes);
          setOriginalActivePurposes(activePurposesRes);
          setIsFetchingActive(false);
          setDisplayFullScreenLoading(false);
        }
      } catch (error) {
        setHasError(true);
      }
    })();

    setRefreshActivePurposes(false);
  }, [activeRefreshPurposes]);

  // auto trigger to update purpose version when token is updated
  useEffect(() => {
    (async () => {
      if (validToAutoTriggerPurpose) {
        if (purposeToDelete) {
          await DeletePurpose({ purposeId: purposeToDelete?.purposeId });

          setPurposeToDelete(undefined);
        }

        if (currentWiggingPurpose) {
          await DeletePurpose({
            purposeId: currentWiggingPurpose?.purposeId,
          });

          await SetPurpose({
            ...currentWiggingPurpose,
            status: PurposeStatusType.active,
          });
        }

        setRefreshActivePurposes(true);
      }

      setRequestToAutoTriggerPurpose(false);
      setValidToAutoTriggerPurpose(false);
    })();
  }, [validToAutoTriggerPurpose]);

  const deletePurpose = async (e: any, purpose: any) => {
    e.stopPropagation();

    const latestPurpose = allPurposes?.find(
      (ap) => ap?.purposeId === purpose?.purposeId,
    );

    const [isReady, reason] = await checkPurposeIsReadyToUse({
      ...purpose,
      version: latestPurpose?.version,
    });

    if (!isReady) {
      return Swal.fire({
        icon: 'warning',
        title: 'Warning!',
        text: 'Please update token first!',
        showCancelButton: true,
        confirmButtonText: 'Update',
      }).then(async (usr) => {
        if (usr.isConfirmed) {
          setRequestToAutoTriggerPurpose(true);
          setShowOneTrustCredentialModal(true);
          setPurposeToDelete(purpose);
        }
      });
    }

    Swal.fire(alertOptions).then((sr) => {
      sr.isConfirmed &&
        DeletePurpose({ purposeId: purpose?.purposeId }).then(
          (response: any) => {
            if (response) {
              setRefreshActivePurposes(true);
            }
          },
        );
    });
  };

  const searchAllPurposes = (e: any) => {
    setAllPurposes(
      backupAllPurposes.filter((p: PurposeType) => {
        return (
          p.label
            .toLocaleLowerCase()
            .indexOf(e.target.value.toLocaleLowerCase()) >= 0 ||
          p.purposeId
            .toLocaleLowerCase()
            .indexOf(e.target.value.toLocaleLowerCase()) >= 0
        );
      }),
    );
  };

  const handlePurposeClassName = (purpose: PurposeType) => {
    let class_name = 'purpose ';

    const isPPT = purpose?.organizations?.some(
      (o) => o === PPT_ORGANIZATION_ID,
    );

    if (isPPT) {
      class_name += 'purpose-blue';
    } else {
      class_name += 'purpose-red';
    }

    return class_name;
  };

  const onDragStart = (result: any) => {
    const purposeId = result.draggableId.split(
      `${result?.source?.droppableId}-`,
    )[1];

    let purposes = allPurposes;
    if (result?.source?.droppableId === 'active') {
      purposes = activePurposes;
    }

    const draggedPurpose = purposes?.find((ap) => ap?.purposeId === purposeId);

    setCurrentWiggingPurpose(draggedPurpose);
  };

  const sortActivePurposes = async (dropResult: any) => {
    if (dropResult?.destination) {
      const tempActivePurposes = placePurposesBeforeApiCall(dropResult);

      const reorderData = tempActivePurposes?.map((p, i) => {
        return {
          purposeId: p.purposeId,
          Sort: i + 1,
        };
      });

      await SortPurpose(reorderData);
      setRefreshActivePurposes(true);
    }
  };

  useEffect(() => {
    if (dropResult?.destination) {
      placePurposesBeforeApiCall(dropResult);
      setDropResult(undefined);
    }
  }, [dropResult]);

  const placePurposesBeforeApiCall = (dropResult: any) => {
    let tempActivePurposes = [...originalActivePurposes];

    const droppingOnSameColumn =
      dropResult?.source?.droppableId === dropResult?.destination?.droppableId;
    const draggedDuplicate = tempActivePurposes?.filter(
      (p) => p?.purposeId === currentWiggingPurpose?.purposeId,
    )?.length
      ? true
      : false;

    if (!droppingOnSameColumn && draggedDuplicate) {
      return tempActivePurposes;
    }

    if (droppingOnSameColumn) {
      tempActivePurposes = tempActivePurposes?.filter(
        (p) => p?.purposeId !== currentWiggingPurpose?.purposeId,
      );
    }

    tempActivePurposes.splice(
      dropResult?.destination?.index,
      0,
      currentWiggingPurpose,
    );

    setActivePurposes(tempActivePurposes);

    return tempActivePurposes;
  };

  const onDragEnd = async (result: any) => {
    setDropResult(result);
    const { source, destination } = result;

    // dropped outside or same section
    if (!destination) {
      resetAllUnnecessaryState();
      return;
    }

    if (destination?.droppableId === 'active') {
      if (source?.droppableId === destination?.droppableId) {
        // sort on same column
        await sortActivePurposes(result);
      } else {
        // drop with sorting from other columns

        // check existing
        const existingActivePurpose = activePurposes?.find(
          (p) => p?.purposeId === currentWiggingPurpose?.purposeId,
        );

        const updatablePurpose = activePurposes?.find(
          (p) =>
            p?.purposeId === currentWiggingPurpose?.purposeId &&
            p?.version !== currentWiggingPurpose?.version,
        );

        if (!updatablePurpose && existingActivePurpose) {
          Swal.fire(duplicateAlertOptions).then(() => {
            setRefreshActivePurposes(true);
            resetAllUnnecessaryState();
          });

          return;
        }

        //   add purpose to destination
        Swal.fire(alertOptions).then(async (sr) => {
          if (sr.isConfirmed) {
            setDisplayFullScreenLoading(true);

            const [isReady, reason] = await checkPurposeIsReadyToUse(
              currentWiggingPurpose,
            );

            setDisplayFullScreenLoading(false);

            if (!isReady) {
              if (updatablePurpose) {
                return Swal.fire({
                  icon: 'warning',
                  title: 'Warning!',
                  text: 'Token is expired. Please update it!',
                  showCancelButton: true,
                  confirmButtonText: 'Update',
                }).then(async (usr) => {
                  if (usr.isConfirmed) {
                    setRequestToAutoTriggerPurpose(true);
                    setShowOneTrustCredentialModal(true);
                  } else {
                    setRequestToAutoTriggerPurpose(false);
                    setRefreshActivePurposes(true);

                    resetAllUnnecessaryState();
                  }
                });
              } else {
                return Swal.fire({
                  icon: 'warning',
                  title: 'Warning!',
                  text: 'Purpose is not ready to use!',
                }).then(() => {
                  setRefreshActivePurposes(true);

                  resetAllUnnecessaryState();
                });
              }
            } else {
              if (updatablePurpose) {
                await DeletePurpose({
                  purposeId: currentWiggingPurpose?.purposeId,
                });
              }

              await SetPurpose({
                ...currentWiggingPurpose,
                status: PurposeStatusType.active,
              });

              await sortActivePurposes(result);

              resetAllUnnecessaryState();
            }
          }

          setRefreshActivePurposes(true);
        });
      }
    } else {
      resetAllUnnecessaryState();
    }
  };

  const getDisabledDragStyle = (style: any, snapshot: any) => {
    if (!snapshot.isDragging) return {};
    if (!snapshot.isDropAnimating) {
      return style;
    }

    return {
      ...style,
      transitionDuration: `0.001s`,
    };
  };

  useEffect(() => {
    if (!showOneTrustCredentialModal) {
      resetAllUnnecessaryState();
      setRefreshActivePurposes(true);
    }
  }, [showOneTrustCredentialModal]);

  const handleOpenOneTrustModal = () => {
    resetAllUnnecessaryState();

    setShowOneTrustCredentialModal(true);
  };

  const resetAllUnnecessaryState = () => {
    setCurrentWiggingPurpose(undefined);
    setPurposeToDelete(undefined);
    setRequestToAutoTriggerPurpose(false);
    setValidToAutoTriggerPurpose(false);
  };

  return (
    <>
      <ConsentDetailModal
        showModal={showModal}
        hideModal={handleCloseModal}
        purposeDetail={purposeDetail}
      />
      <OneTrustCredentialModal
        showModal={showOneTrustCredentialModal}
        hideModal={() => setShowOneTrustCredentialModal(false)}
        requestToAutoTriggerPurpose={requestToAutoTriggerPurpose}
        setValidToAutoTriggerPurpose={setValidToAutoTriggerPurpose}
        purpose={currentWiggingPurpose}
        purposeToDelete={purposeToDelete}
        allPurposes={allPurposes}
      />
      <EmailConfigModal
        showModal={showEmailConfigModal}
        hideModal={() => setShowEmailConfigModal(false)}
      />

      <div className="container-fiuld master-layout manage-consent">
        <Sidemenu
          hasError={hasError}
          displayFullScreenLoading={displayFullScreenLoading}
        />
        <div className="main-container">
          <div className="col-12 mb-4">
            <Topbar />
          </div>
          <div className="container-fuild">
            <div className="one-trust-credential-wrapper" style={{ display: 'flex', gap: '10px' }}>
              <Button
                variant="outline-success"
                type="button"
                onClick={() => setShowEmailConfigModal(true)}
              >
                <Icon.Envelope className="me-1" />
                Email Configuration
              </Button>
              <Button
                variant="outline-primary"
                type="button"
                onClick={handleOpenOneTrustModal}
              >
                OneTrust Credential
              </Button>
            </div>

            <div className="row align-items-stretch">
              <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
                <div className="col-4 d-flex flex-column">
                  <div className="block-shadow py-0 px-0 d-flex flex-column" style={{ height: '70vh' }}>
                    <div className="board-title header-all">
                      <h3>Purpose - All</h3>
                      <p>List Of Purpose Available in Onetrust</p>
                    </div>
                    <div style={{ padding: '1rem', flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                      <InputGroup className="mb-3">
                        <Form.Control
                          placeholder="Enter keyword"
                          onChange={searchAllPurposes}
                        />
                        <InputGroup.Text>
                          <Icon.Search />
                        </InputGroup.Text>
                      </InputGroup>

                      <Droppable droppableId="all" isDropDisabled={true}>
                        {(provided, snapshot) => (
                          <div className="purposes" ref={provided.innerRef} style={{ flex: 1, overflowY: 'auto' }}>
                            {isFetchingAll && (
                              <div className="loader-box">
                                <div className="spinner"></div>
                              </div>
                            )}

                            {allPurposes?.map((allPurpose, i) => (
                              <Draggable
                                key={`all-${allPurpose?.purposeId}`}
                                draggableId={`all-${allPurpose?.purposeId}`}
                                index={i}
                              >
                                {(provided, snapshot) => (
                                  <>
                                    <div
                                      className={handlePurposeClassName(
                                        allPurpose,
                                      )}
                                      onClick={() =>
                                        handleShowModal(allPurpose)
                                      }
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      style={getDisabledDragStyle(
                                        provided.draggableProps.style,
                                        snapshot,
                                      )}
                                    >
                                      <p className="font-weight-bold">
                                        {allPurpose?.label}
                                      </p>
                                      <p>ID: {allPurpose?.purposeId}</p>
                                      <p>Version: {allPurpose?.version}</p>
                                    </div>
                                    {snapshot.isDragging && (
                                      <div
                                        className={handlePurposeClassName(
                                          allPurpose,
                                        )}
                                      >
                                        <p className="font-weight-bold">
                                          {allPurpose?.label}
                                        </p>
                                        <p>ID: {allPurpose?.purposeId}</p>
                                        <p>Version: {allPurpose?.version}</p>
                                      </div>
                                    )}
                                  </>
                                )}
                              </Draggable>
                            ))}
                          </div>
                        )}
                      </Droppable>
                    </div>
                  </div>
                </div>

                <div className="col-4 d-flex flex-column">
                  <div className="block-shadow py-0 px-0 d-flex flex-column" style={{ height: '70vh' }}>
                    <div className="board-title header-pending">
                      <h3>Purpose - PPV Specific</h3>
                      <p>Pending</p>
                    </div>
                    <div style={{ padding: '1rem', flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

                      <Droppable droppableId="buffer" isDropDisabled={true}>
                        {(provided, snapshot) => (
                          <div className="purposes" ref={provided.innerRef} style={{ flex: 1, overflowY: 'auto' }}>
                            {isFetchingPending && (
                              <div className="loader-box">
                                <div className="spinner"></div>
                              </div>
                            )}

                            {bufferPurposes?.map((bufferPurpose, i) => (
                              <Draggable
                                key={`buffer-${bufferPurpose?.purposeId}`}
                                draggableId={`buffer-${bufferPurpose?.purposeId}`}
                                index={i}
                              >
                                {(provided, snapshot) => (
                                  <>
                                    <div
                                      className="purpose purpose-amber"
                                      onClick={() =>
                                        handleShowModal(bufferPurpose)
                                      }
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      style={getDisabledDragStyle(
                                        provided.draggableProps.style,
                                        snapshot,
                                      )}
                                    >
                                      <p className="font-weight-bold">
                                        {bufferPurpose?.label}
                                      </p>
                                      <p>ID: {bufferPurpose?.purposeId}</p>
                                      <p>Version: {bufferPurpose?.version}</p>
                                    </div>

                                    {snapshot.isDragging && (
                                      <div className="purpose purpose-amber">
                                        <p className="font-weight-bold">
                                          {bufferPurpose?.label}
                                        </p>
                                        <p>ID: {bufferPurpose?.purposeId}</p>
                                        <p>Version: {bufferPurpose?.version}</p>
                                      </div>
                                    )}
                                  </>
                                )}
                              </Draggable>
                            ))}
                            <span
                              style={{
                                display: 'none',
                              }}
                            >
                              {provided.placeholder}
                            </span>
                          </div>
                        )}
                      </Droppable>
                    </div>
                  </div>
                </div>

                <div className="col-4 d-flex flex-column">
                  <Droppable droppableId="active">
                    {(provided, snapshot) => (
                      <div
                        className={`block-shadow py-0 px-0 d-flex flex-column ${
                          snapshot.isDraggingOver ? 'droppable-area' : ''
                        }`}
                        style={{ height: '70vh' }}
                      >
                        <div className="board-title header-active">
                          <h3>Purpose - PPV Active</h3>
                          <p>Active For PPV</p>
                        </div>
                        <div style={{ padding: '1rem', flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

                          <div className="purposes" ref={provided.innerRef} style={{ flex: 1, overflowY: 'auto' }}>
                            {isFetchingActive && (
                              <div className="loader-box">
                                <div className="spinner"></div>
                              </div>
                            )}

                            {activePurposes?.map((activePurpose, i) => (
                              <Draggable
                                key={`active-${activePurpose?.purposeId}`}
                                draggableId={`active-${activePurpose?.purposeId}`}
                                index={i}
                              >
                                {(provided, snapshot) => (
                                  <div
                                    key={i}
                                    className="purpose purpose-green"
                                    onClick={() =>
                                      handleShowModal(activePurpose)
                                    }
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    <Icon.DashSquare
                                      className="purpose-remove-btn"
                                      onClick={(e) =>
                                        deletePurpose(e, activePurpose)
                                      }
                                    />
                                    <p className="font-weight-bold">
                                      {activePurpose?.label}
                                    </p>
                                    <p>ID: {activePurpose?.purposeId}</p>
                                    <p>
                                      Version: {activePurpose?.version}
                                      {activePurpose?.versionUpdate && (
                                        <span className="new-version-label">
                                          New Version Available
                                        </span>
                                      )}
                                    </p>
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        </div>
                      </div>
                    )}
                  </Droppable>
                </div>
              </DragDropContext>
            </div>
          </div>
          <div className="col-12">
            <Footer />
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
};
